import { render, staticRenderFns } from "./SendDocumentModal.vue?vue&type=template&id=8fa9b3fe&"
import script from "./SendDocumentModal.vue?vue&type=script&lang=js&"
export * from "./SendDocumentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Abdelaziz\\Documents\\depot\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8fa9b3fe')) {
      api.createRecord('8fa9b3fe', component.options)
    } else {
      api.reload('8fa9b3fe', component.options)
    }
    module.hot.accept("./SendDocumentModal.vue?vue&type=template&id=8fa9b3fe&", function () {
      api.rerender('8fa9b3fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/base/modal/SendDocumentModal.vue"
export default component.exports